
    import Vue from "vue";
    import Component from "vue-class-component";
    import AppFooter from "@/features/shared/components/AppFooter.vue";
    import { Prop } from "vue-property-decorator";
    import { UserInfoResponse } from "@/api-client";
    import LandingpageIllustration from "@/components/LandingpageIllustration.vue";
    import {  authService} from "@/AuthService";

    @Component({
        components: {
            LandingpageIllustration,
            AppFooter
        },
    })
    export default class Home extends Vue {
        authService = authService;

        get isLoggedIn(): boolean {
            return this.authService.isLoggedIn;
        }
        
        async logIn(){
            const returnUrl = window.location.pathname + window.location.search;
            await this.authService.startAuthentication(encodeURI(returnUrl));
        }
    }
